export default "__VITE_ASSET__D_jCP6od__"